module.exports = __webpack_public_path__ + "staticcomp/img/content_1.446df0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/content_1.jpg
// module id = 4IHq
// module chunks = 39